import * as betprofessor from './IncreaseAmountButton.styles.betprofessor';
import * as betroyale from './IncreaseAmountButton.styles.betroyale';
import * as fiestabet from './IncreaseAmountButton.styles.fiestabet';
import * as goldenrush from './IncreaseAmountButton.styles.goldenrush';
import * as juicybet from './IncreaseAmountButton.styles.juicybet';
import * as puntcity from './IncreaseAmountButton.styles.puntcity';
import * as puntgenie from './IncreaseAmountButton.styles.puntgenie';
import * as questbet from './IncreaseAmountButton.styles.questbet';
import * as sterlingparker from './IncreaseAmountButton.styles.sterlingparker';
import * as vikingbet from './IncreaseAmountButton.styles.vikingbet';
import * as volcanobet from './IncreaseAmountButton.styles.volcanobet';
import * as forsport from './IncreaseAmountButton.styles.forsport';
import * as junglebet from './IncreaseAmountButton.styles.junglebet';
import * as oldgill from './IncreaseAmountButton.styles.oldgill';
import * as sugarcastle from './IncreaseAmountButton.styles.sugarcastle';
import * as buffalobet from './IncreaseAmountButton.styles.buffalobet';
import * as betgalaxy from './IncreaseAmountButton.styles.betgalaxy';
import * as titanbet from './IncreaseAmountButton.styles.titanbet';
import * as slambet from './IncreaseAmountButton.styles.slambet';
import * as gigabet from './IncreaseAmountButton.styles.gigabet';
import * as betstride from './IncreaseAmountButton.styles.betstride';
import * as templebet from './IncreaseAmountButton.styles.templebet';
import * as goldenbet888 from './IncreaseAmountButton.styles.goldenbet888';
import * as hyperbet from './IncreaseAmountButton.styles.hyperbet';
import * as bet777 from './IncreaseAmountButton.styles.bet777';
import * as chromabet from './IncreaseAmountButton.styles.chromabet';
import * as bet575 from './IncreaseAmountButton.styles.bet575';
import * as betblast from './IncreaseAmountButton.styles.betblast';
import * as pyramidbet from './IncreaseAmountButton.styles.pyramidbet';
import * as magnumbet from './IncreaseAmountButton.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  betgalaxy,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
